module.exports = "┏━━━━━┓\n┣━━━┳━┫\n┃╱╱╱┃╱┃\n┃╱╱╱┃╱┃\n┃╱╱╱┃╱┃\n┗━━━┻━┛\n";


//////////////////
// WEBPACK FOOTER
// ./src/templates/article-header/article-header.preview.html
// module id = 285
// module chunks = 0